/**
 * Created by spepa on 18.02.21
 */

const CurtainCardView = CardView.extend({
    ctor: function (card) {
        this._super(card);

        this.setAnchorPoint(0.5, 0.5);

        this.curtains = new cleverapps.Spine(bundles.card.jsons.curtain_json);
        this.curtains.setPosition(this.width / 2, this.height / 2);
        this.curtains.setVisible(false);
        this.addChild(this.curtains);

        this.counterText = cleverapps.UI.generateImageText(this.getCounterText(), cleverapps.styles.FONTS.CURTAIN_COUNTER_TEXT);
        this.counterText.setAlignment(cleverapps.styles.CurtainCardView.counter);
        this.curtains.addChild(this.counterText);
        this.updateCurtainsVisibility();
        card.on("hide", this.hide.bind(this));
        card.on("changeStage", this.changeStage.bind(this));
        card.on("onshowup", this.updateCurtainsVisibility.bind(this));

        if (cleverapps.environment.isEditorScene()) {
            this.addEditorControls();
        }
    },

    onEnter: function () {
        this._super();
        if (this.parent instanceof OpenCardsView) {
            this.hide();
        }
    },

    hide: function () {
        if (this.curtains) {
            this.curtains.removeFromParent();
        }
    },

    getCounterText: function () {
        if (this.card.sleeping) {
            return this.card.sleep - this.card.counter;
        }
        return this.card.active - this.card.counter;
    },

    getAnimationName: function () {
        const state = this.card.sleeping ? "sleep" : "active";
        return this.card.magicCurtain ? (`magic_${state}`) : state;
    },

    getIdleAnimationName: function () {
        return `${this.getAnimationName()}_idle`;
    },

    getWrongMoveAnimationName: function () {
        return `${this.getAnimationName()}_wrong_move`;
    },

    changeStage: function () {
        if (!this.curtains.visible) {
            return;
        }

        if (this.card.counter === 0) {
            this.counterText.setString(0);
            this.curtains.setAnimation(0, this.getAnimationName(), false);

            this.curtains.setCompleteListener(() => {
                this.curtains.setCompleteListener();
                if (!this.curtains.visible) {
                    return;
                }

                this.curtains.setAnimation(0, this.getIdleAnimationName(), true);
                this.counterText.setString(this.getCounterText());
            });
            cleverapps.effects.fire(this.card.sleeping ? "solitaire.curtain.close" : "solitaire.curtain.open");
        } else {
            this.counterText.setString(this.getCounterText());
        }
    },

    animateReturnToScreen: function () {
        this._super();

        this.updateCurtainsVisibility();
    },

    updateCurtainsVisibility: function () {
        if (this.card.sleeping) {
            cleverapps.effects.fire("solitaire.curtain.close");
            this.curtains.setAnimationAndIdleAfter(this.getAnimationName(), this.getIdleAnimationName());
        } else {
            this.curtains.setAnimationAndIdleAfter("emerging", this.getIdleAnimationName());
        }
    },

    animateLose: function (index) {
        if (this.curtains) {
            this.curtains.removeFromParent();
        }
        return CardView.prototype.animateLose.call(this, index);
    },

    wrongMove: function () {
        const wrongAnimation = this.getWrongMoveAnimationName();
        if (this.curtains.hasAnimation(wrongAnimation)) {
            cleverapps.effects.fire("tile3.wrong");
            this.curtains.setAnimationAndIdleAfter(wrongAnimation, this.getIdleAnimationName());
        } else {
            this._super();
        }
    },

    addEditorControls: function () {
        const activeBlock = new IncDecBlock({
            value: this.card.active,
            onChange: function (value) {
                this.card.active = value;
                this.changeStage();
                Editor.currentEditor.save();
            }.bind(this)
        });
        const sleepBlock = new IncDecBlock({
            value: this.card.sleep,
            onChange: function (value) {
                this.card.sleep = value;
                this.changeStage();
                Editor.currentEditor.save();
            }.bind(this)
        });
        const checkboxSleeping = new cleverapps.UI.CheckBox({
            isSelected: this.card.sleeping || false,
            label: {
                text: "sleeping"
            },
            onChange: function (state) {
                this.card.sleeping = state;
                this.changeStage();
                Editor.currentEditor.save();
            }.bind(this)
        });
        const checkboxMagic = new cleverapps.UI.CheckBox({
            isSelected: this.card.magicCurtain || false,
            label: {
                text: "magic"
            },
            onChange: function (state) {
                this.card.magicCurtain = state;
                this.changeStage();
                Editor.currentEditor.save();
            }.bind(this)
        });
        const controls = new cleverapps.Layout([activeBlock, sleepBlock, checkboxSleeping, checkboxMagic], {
            direction: cleverapps.UI.VERTICAL
        });

        controls.setScale(0.4);
        controls.setPosition(this.width / 2, this.height / 2);
        this.addChild(controls);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    CURTAIN_COUNTER_TEXT: {
        size: 0,
        name: "default"
    }
});

cleverapps.styles.CurtainCardView = {
    counter: {
        x: { align: "center" },
        y: { align: "center", dy: -6 }
    }
};